var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9003 11.7435V23.6567C19.5905 22.9043 17.9742 22.6117 16.2604 23.2109C14.3933 23.8797 12.9581 25.5378 12.6237 27.4885C12.4691 28.3662 12.5269 29.2682 12.7922 30.119C13.0575 30.9699 13.5227 31.7448 14.1488 32.3791C14.7749 33.0134 15.5437 33.4886 16.3911 33.7649C17.2384 34.0413 18.1395 34.1108 19.0192 33.9676C21.7502 33.5357 23.687 31.0276 23.687 28.2548V14.5302H26.4737C28.0064 14.5302 29.2604 13.2762 29.2604 11.7435C29.2604 10.2108 28.0064 8.95679 26.4737 8.95679H23.687C22.1543 8.95679 20.9003 10.2108 20.9003 11.7435Z",
    fill: "#FF9A1F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAudio);
export default __webpack_public_path__ + "static/media/ic_audio.c182b5a1440ebe588e79fde99d3a3cad.svg";
export { ForwardRef as ReactComponent };